import StyledWrapper2 from '../../../../IndividualProgram/style';
import { formatTimestamp } from '../../../../../utils/dateUtils';

import { checkOverflow } from '../../../../../utils/utilFunctions';
import Tooltip from '@mui/material/Tooltip';

const BasicCellText = ({
	cellValues,
	openTooltip,
	setOpenTooltip,
	StartIcon,
	isLink,
	isDate,
	emptyDefaultValue,
	isDisabled
}) => {
	const formattedText = isDate
		? formatTimestamp(cellValues?.formattedValue)
		: cellValues?.formattedValue;

	return (
		<Tooltip
			open={openTooltip === `${cellValues?.field}-${cellValues?.stage_id}`}
			onOpen={(e) =>
				checkOverflow(e) && setOpenTooltip(`${cellValues?.field}-${cellValues?.stage_id}`)
			}
			onClose={() => setOpenTooltip(0)}
			arrow
			placement="top"
			title={cellValues?.formattedValue ? formattedText : !emptyDefaultValue && 'n/a'}
		>
			<StyledWrapper2.CellContainer
				data-testid={`cellContainer-${cellValues?.field}-${cellValues?.stage_id}`}
			>
				{cellValues?.formattedValue && StartIcon && <StartIcon />}
				{!isLink ? (
					<StyledWrapper2.CardRowInfo
						width={'100%'}
						isDisabled={isDisabled}
						data-testid={`rowInfo-${cellValues?.field}-${cellValues?.stage_id}`}
					>
						{cellValues?.formattedValue ? formattedText : !emptyDefaultValue && 'n/a'}
					</StyledWrapper2.CardRowInfo>
				) : (
					<StyledWrapper2.CardRowInfoLink
						width={'100%'}
						isDisabled={isDisabled}
						data-testid={`rowLink-${cellValues?.field}-${cellValues?.stage_id}`}
					>
						{cellValues?.formattedValue ? formattedText : !emptyDefaultValue && 'n/a'}
					</StyledWrapper2.CardRowInfoLink>
				)}
			</StyledWrapper2.CellContainer>
		</Tooltip>
	);
};

export default BasicCellText;
